import { filter } from "lodash";
import { Icon } from "@iconify/react";
import { sentenceCase } from "change-case";
import { useEffect, useState } from "react";
import iconEdit2 from "@iconify/icons-eva/edit-2-outline";
import { Link as RouterLink, useNavigate } from "react-router-dom";
import moment from "moment";
// material
import { Card, Table, Stack, Avatar, TableRow, TableBody, TableCell, Container, Typography, TableContainer, TextField, Button, RadioGroup, Radio, FormControlLabel } from "@mui/material";
// components
import Page from "src/components/Page";
import Scrollbar from "src/components/Scrollbar";
import SearchNotFound from "src/components/SearchNotFound";
import plusFill from "@iconify/icons-eva/plus-fill";

import axios from "axios";
import StringUtil from "src/utils/StringUtil";
import MoreMenu from "src/components/common/MoreMenu";
import ListHead from "src/components/common/ListHead";
import ListToolbar from "src/components/common/ListToolbar";
import { alert } from "src/services/alert";
import MyPagination from "src/components/common/MyPagination";
import Label from "src/components/Label";
import FormDialog from "src/components/common/FormDialog";
import AccessControls from "src/components/AccessControls";
import FormItem from "src/components/form-item/FormItem";

const TABLE_HEAD = [
  { id: "id", label: "ID", alignRight: false }, 
  { id: "name", label: "角色", alignRight: false }, 
  { id: "access", label: "权限", alignRight: false }, 
  { id: "status", label: "状态", alignRight: false }, 
  { id: "createdAt", label: "创建时间", alignRight: false }, 
  { id: "操作" }
];

const moreMenus = [{ title: "编辑", icon: iconEdit2 }];

export default function SupplierRole() {
  const navigate = useNavigate();
  const [selected, setSelected] = useState([]);

  const [items, setItems] = useState([]);
  const [total, setTotal] = useState(0);

  const [filter, setFilter] = useState({
    page: 1,
    size: 10,
    search: "",
  });

  const [action, setAction] = useState("");
  const [targetItem, setTaretItem] = useState({});
  const [form, setForm] = useState({
    name: "",
    status: 1,
    accessCtrls: [],
  });

  useEffect(() => {
    axios
      .post("/system/role/all", filter)
      .then((res) => {
        const { code, msg, data, count } = res.data;
        if (code === 1) {
          setItems(data);
          setTotal(count);
        } else {
          alert(msg);
        }
      })
      .catch((err) => {});
  }, [filter]);

  const handlePageChange = (event, value) => {
    const newPage = value;
    if (newPage === filter.page) return;
    setFilter({
      ...filter,
      page: newPage,
    });
  };

  const handleFilterByName = (event) => {
    setFilter({
      ...filter,
      search: event.target.value,
    });
  };

  const handleMoreClick = (type, row) => {
    if (type === "编辑") {
      // navigate(`/user/detail/${row.uid}`);
      setForm({
        name: row.name,
        status: row.status,
        accessCtrls: row.accessCtrls ? row.accessCtrls.split(',').map((a) => parseInt(a)) : [],
      });
      setTaretItem(row);
      setAction("edit");
    }
  };

  // dialog
  function handleAddItem() {
    setAction("add");
    setForm({
      name: "",
      status: 1,
    });
  }

  function handleIptChange(ki, val) {
    setForm({
      ...form,
      [ki]: val,
    });
  }

  function handleDialogConfirm() {
    const formData = { ...form };

    if (action === "edit") {
      formData.id = targetItem.id;
    }

    formData.accessCtrls = form.accessCtrls.join(",");

    // return console.log(formData)

    axios
      .post(action === "add" ? "/system/role/add" : "/system/role/edit", formData)
      .then((res) => {
        const { code, msg, data } = res.data;
        if (code === 1) {
          if (action === "add") {
            setItems([...items, data]);
          } else if (action === "edit") {
            const item = items.find((b) => b.id === targetItem.id);
            item.name = formData.name;
            item.status = parseInt(formData.status);
            item.accessCtrls = formData.accessCtrls;
            setItems([...items]);
          }

          setAction("");
        } else {
          alert(msg);
        }
      })
      .catch((err) => {
        console.log("添加或修改角色失败: ", err);
      });
  }

  const emptyRows = filter.size - items.length;
  const isUserNotFound = items.length === 0;

  return (
    <Page title="角色管理">
      <Container maxWidth="2000px">
        <Stack direction="row" alignItems="center" justifyContent="space-between" mb={5}>
          <Typography variant="h4" gutterBottom>
            角色管理
          </Typography>

          <Button variant="contained" to="add" startIcon={<Icon icon={plusFill} />} onClick={handleAddItem}>
            添加角色
          </Button>
        </Stack>

        <Card>
          <ListToolbar filterName={filter.search} onFilterName={handleFilterByName} />

          <Scrollbar>
            <TableContainer sx={{ minWidth: 800 }}>
              <Table>
                <ListHead headLabel={TABLE_HEAD} />
                <TableBody>
                  {items.map((row) => {
                    const { id, avatar, name, accessCtrls, createdAt, status } = row;
                    const isItemSelected = selected.indexOf(name) !== -1;

                    return (
                      <TableRow hover key={id} tabIndex={-1} role="checkbox" selected={isItemSelected} aria-checked={isItemSelected}>
                        {/* <TableCell padding="checkbox">
                            <Checkbox
                              checked={isItemSelected}
                              onChange={(event) => handleClick(event, id)}
                            />
                          </TableCell> */}
                        <TableCell align="left">{id}</TableCell>
                        <TableCell align="left">{name}</TableCell>
                        <TableCell align="left">{accessCtrls}</TableCell>
                        <TableCell>
                          <Label variant="ghost" color={["default", "success"][status]}>
                            {["关闭", "开启"][status]}
                          </Label>
                        </TableCell>
                        <TableCell align="left">{moment(createdAt).format("YYYY-MM-DD HH:mm:ss")}</TableCell>
                        <TableCell align="right">
                          <MoreMenu menus={moreMenus} onMoreClick={(type) => handleMoreClick(type, row)} />
                        </TableCell>
                      </TableRow>
                    );
                  })}
                  {/* {emptyRows > 0 && (
                    <TableRow style={{ height: 50 * emptyRows }}>
                      <TableCell colSpan={2} />
                    </TableRow>
                  )} */}
                </TableBody>
                {isUserNotFound && (
                  <TableBody>
                    <TableRow>
                      <TableCell align="center" colSpan={6} sx={{ py: 5 }}>
                        <SearchNotFound searchQuery={filter.search} />
                      </TableCell>
                    </TableRow>
                  </TableBody>
                )}
              </Table>
            </TableContainer>
          </Scrollbar>

          <MyPagination total={total} page={filter.page} size={filter.size} onChange={handlePageChange} />
        </Card>
      </Container>

      <FormDialog sx={{overflow: 'hidden'}} title={action === "add" ? "添加角色" : "修改角色"} open={!!action} onClose={() => setAction()} onConfirm={handleDialogConfirm}>
        <FormItem title="角色名称" required>
          <TextField placeholder="角色名称" autoComplete="off" id="name" value={form.name} size="small" onChange={(e) => handleIptChange("name", e.target.value)} />
        </FormItem>

        <FormItem title="是否启用" required>
          <RadioGroup row aria-label="gender" name="row-radio-buttons-group" value={form.status}>
            <FormControlLabel value={0} control={<Radio />} label="关闭" onChange={(e) => handleIptChange("status", e.target.value)} />
            <FormControlLabel value={1} control={<Radio />} label="开启" onChange={(e) => handleIptChange("status", e.target.value)} />
          </RadioGroup>
        </FormItem>

        <FormItem>
          <AccessControls defaultCtrls={form.accessCtrls} onChange={(val) => handleIptChange("accessCtrls", val)} />
        </FormItem>
      </FormDialog>
    </Page>
  );
}
